import { apiLink } from '../../constants/env';
import axiosInstance, { AxiosAuth } from '../AxiosInstance';

const apiEmpresa = {
    fetchApi: async (page, pageSize = 10) => {
        const URL = `/api/empresa/paged?page=${page}&pageSize=${pageSize}`; ;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    getById: async (id) => {
        const URL = `/api/empresa/` + id;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    postApi: async (empresa) => {
        const URL = `/api/empresa`;
        return await AxiosAuth.post(URL, empresa)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    deleteApi: async (id) => {
        const URL = `/api/empresa/status/${id}`;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    putApi: async (id, empresa) => {
        const URL = `/api/empresa/${id}`;
        return await AxiosAuth.put(URL, empresa)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    getByGrupoApi: async (id) => {
        const URL = `/api/empresa/grupo/${id}`;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    }

}

export default apiEmpresa;

